const initState=[];
const PatientRecordReducer = (state = initState, action) => {
    switch(action.type) {
        case  'PatientRecordAction' : return  action.payload ;
        default: return state;
    }
}
export default PatientRecordReducer;